.data_entry_source_number {
  text-align: center;
  font-family: var(--font-header);
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2rem;
  padding: 0.5rem 1rem;
  background: var(--base-accent);
  color: var(--base-white);
}

.sm {
  font-size: 1.25rem;
  line-height: 1.9rem;
  padding: 0 0.5rem;
}

.data_entry_section {
  font-family: var(--font-text);
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.75rem;
  padding: 0 0.5rem;
  border-radius: 0.25rem;
  background: var(--blue-300);
  color: var(--base-black);
  white-space: nowrap;
}

.badge {
  text-align: center;
  font-family: var(--font-text);
  font-size: var(--font-size-sm);
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  border: 2px solid var(--base-white);
  display: inline-flex;
  gap: 0.5rem;
  min-width: fit-content;
  max-width: fit-content;
  align-items: center;
}

.correction {
  background: var(--badge-correction-bg);
  border: 1px solid var(--badge-correction-border);
  color: var(--badge-correction);
}

.definitive {
  background: var(--badge-definitive-bg);
  color: var(--badge-definitive);
}

.difference {
  background: var(--badge-difference-bg);
  color: var(--badge-difference);
}

.empty,
.first_entry_in_progress,
.first_entry_correction,
.first_entry_has_errors,
.first_entry_finalised {
  background: var(--badge-second-entry-bg);
  border: 1px solid var(--badge-second-entry-border);
  color: var(--badge-second-entry);
}

.objections {
  background: var(--badge-objections-bg);
  border: 1px solid var(--badge-objections-border);
  color: var(--badge-objections);
}

.first_entry_finalised_for_typist,
.second_entry_in_progress,
.second_entry_correction,
.entries_different,
.extra_entry {
  background: var(--badge-first-entry-bg);
  border: 1px solid var(--badge-first-entry-border);
  color: var(--badge-first-entry);
}

.typist_busy {
  background: var(--badge-typist-busy-bg);
  border: 1px solid var(--badge-typist-busy-border);
  color: var(--badge-typist-busy);
}
